/** Mock picker — marketing/conversion page (keep site chrome). */
export const MOCK_PICKER_PATH = '/quiz/session';

/**
 * Strip trailing slashes (Netlify serves prerendered pages at `/path/` and 301s `/path`
 * there), so `/quiz/session/` is treated exactly like `/quiz/session`. Root stays `/`.
 */
export function normalizeRoutePath(pathname = '') {
  const path = String(pathname || '').split(/[?#]/)[0];
  const trimmed = path.replace(/\/+$/, '');
  return trimmed || (path ? '/' : '');
}

export function isMockPickerPath(pathname = '') {
  return normalizeRoutePath(pathname) === MOCK_PICKER_PATH;
}

/** Any /quiz route including picker and active sessions. */
export function isQuizPath(pathname = '') {
  const path = normalizeRoutePath(pathname);
  return path === '/quiz' || path.startsWith('/quiz/');
}

/**
 * Active timed drill or mock (hide nav during questions only — not picker, preflight, or results).
 * Pair with QuizContext.hideSiteChrome for in-session state.
 */
export function isActiveQuizPath(pathname = '') {
  return isQuizPath(pathname) && !isMockPickerPath(pathname);
}

export function shouldHideSiteChrome(pathname = '', hideSiteChrome = false) {
  return isActiveQuizPath(pathname) || hideSiteChrome;
}
